import React, { Component } from 'react'
import { connect } from 'react-redux'
import { dispatch } from '../../jsCore/application/appStore'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { recommendedListReducers } from '../../jsCore/store/recommendedVideos/recommendedVideos.reducers'
import {
  recievedRecommedationsAction,
  recievedErrorAction,
} from '../../jsCore/store/recommendedVideos/recommendedVideos.actions'
import { getDataByProvider } from '../../jsCore/store/recommendedVideos/recommendedVideos.providers'
import { RecommendedHeader } from './components/recommendedHeader'
import { RecommendedList } from './components/recommendedList'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { findDOMNode } from 'react-dom'

const componentName = 'recommendedVideos'
const stateKey = componentName

function payloadMapper(playerId, item) {
  item.hlink = `/videos/${playerId}/${item.mediaId}`
  return item
}

function normalizePayload(playerId, payload) {
  const recommendedItemsMapper = payloadMapper.bind(null, playerId)
  return {
    recommendedItems: payload.map(recommendedItemsMapper),
  }
}

function dispatchNormalizedVideoPaylaod(payload) {
  return dispatch(recievedRecommedationsAction(payload))
}

function dispatchRecievedError(payload) {
  return dispatch(recievedErrorAction(payload))
}

export class RecommendedVideosComponent extends Component {
  componentWillMount() {
    const providerName = 'jw'
    const { playerId, videoId, playlistId } = findDOMNode(this).parentNode.dataset
    const normalizeVideoPayload = normalizePayload.bind(null, playerId)
    getDataByProvider({ providerName, playlistId, videoId })
      .then(normalizeVideoPayload)
      .then(dispatchNormalizedVideoPaylaod)
      .catch(dispatchRecievedError)
  }

  render() {
    const { recommendedItems: itemsList, isInitialized, recievedError } = this.props
    const {
      analyticsEventAction,
      analyticsEventCategory,
      analyticsEventLabel,
      analyticsEventValue,
    } = findDOMNode(this).parentNode.dataset
    const recommendedVideosProps = {
      itemsList,
      isInitialized,
      recievedError,
      analyticsEventAction,
      analyticsEventCategory,
      analyticsEventLabel,
      analyticsEventValue,
    }
    return recievedError ? (
      <noscript />
    ) : (
      <div className="recommended-videos">
        <RecommendedHeader />
        <RecommendedList {...recommendedVideosProps} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { isInitialized, recommendedItems, recievedError } = state[stateKey]
  return {
    isInitialized,
    recommendedItems,
    recievedError,
  }
}

const recommendedVideosContainer = {
  name: componentName,
  stateKey,
  component: connect(mapStateToProps, { recievedRecommedationsAction })(RecommendedVideosComponent),
  reducer: recommendedListReducers,
}

function mountRecommendedVideos() {
  return reduxMount({
    [MOUNT_POINTS.RECOMMENDED_VIDEOS_CONTAINER]: recommendedVideosContainer,
  })
}

export default function initRecommendedVideos() {
  mountRecommendedVideos()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedVideos/recommendedVideos.container.js